import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import locale from 'antd/lib/locale/pt_BR';
import moment from 'moment';

interface ModalEditarServicoProps {
    modalStatus?: any,
    setEditarServicoModal?: any
}

const ModalEditarServico: React.FC<ModalEditarServicoProps> = (prop) => {

    let visible = prop.modalStatus[0].visibleEditarServico    
    const [form] = Form.useForm();
    const { Option } = Select;
    const [loading, setLoading] = useState(false);
    const [ativo, setAtivo] = useState();

    useEffect(() => {          
        form.resetFields();
        if (prop.modalStatus[0].servico != null) {          
            form.setFieldsValue({ servicoID: prop.modalStatus[0].servico.servicoID })                        
            form.setFieldsValue({ descricao: prop.modalStatus[0].servico.descricao })            
            setAtivo(prop.modalStatus[0].servico.ativo)
        }
    }, [visible])

    const onFinish = (values: any) => {
        setLoading(true)
        api.put(`Servico`, {
            ServicoID: values.servicoID,
            Descricao: values.descricao,
            Ativo: ativo,
        })
            .finally(() => setLoading(false))
            .then((response) => {
                if (response.data.valido) {
                    message.success('Serviço editado com Sucesso')
                    prop.setEditarServicoModal(false);

                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => { message.error('Falha na requisição') })
        }

        const handleCancel = () => {
            prop.setEditarServicoModal(false)

        }
        return (
            <Modal
                visible={visible}
                title="Editar Serviço"
                footer={null}
                onCancel={handleCancel}
            >
                <Form name="basic" form={form} onFinish={onFinish}    labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} >                   
                    <Form.Item label="ServicoID" name="servicoID" hidden={true}>                                                                    
                        <Input type="number" hidden={true} />
                    </Form.Item>                   
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        
                        <Col className="gutter-row" span={24}>
                            <Form.Item
                                label="Descricao"
                                name="descricao"
                            >
                                <Input placeholder="Digite a descrição"></Input>
                            </Form.Item>
                        </Col>                                                         
                    </Row>                  
                    <Form.Item>
                        <Button loading={loading} className="button-pre-cadastro" type="primary" htmlType="submit">
                            Editar
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>)


    }

    const mapStateToProps = (state: any) => ({
        modalStatus: state.modalStatus,
    })

    const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)
    export default connect(mapStateToProps, mapDispatcToProps)(ModalEditarServico);